import React from 'react';
import { colors } from '@/theme/colors';
import { cn } from '@/shadcn-ui/utils';

interface ArrowLeftProps {
  className?: string;
  fill?: string;
}

const ArrowLeft: React.FC<ArrowLeftProps> = ({ className, fill = colors.neutral1 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.707 6.29289C15.0975 6.68342 15.0975 7.31658 14.707 7.70711L10.4141 12L14.707 16.2929C15.0975 16.6834 15.0975 17.3166 14.707 17.7071C14.3165 18.0976 13.6833 18.0976 13.2928 17.7071L8.29277 12.7071C7.90225 12.3166 7.90225 11.6834 8.29277 11.2929L13.2928 6.29289C13.6833 5.90237 14.3165 5.90237 14.707 6.29289Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowLeft;
